import {RepositoryFactory} from '@/repository/RepositoryFactory';
import { is_live } from "@/constants/config";
const CustomerRepository = RepositoryFactory.get('customer');
const SupplierRepository = RepositoryFactory.get('supplier');
const FormulationRepository = RepositoryFactory.get('formulations')
const DropDownRepository = RepositoryFactory.get('drop_down')
const CustomerSourceRepository = RepositoryFactory.get('customer_source')
const StaffRepository = RepositoryFactory.get('staff')
const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial');
const CrmRepository = RepositoryFactory.get("crm");

export default {
  state: {
    customers: [],
    countries: [],
    suppliers: [],
    staffs: [],
    filtered_staffs: [],
    industry_sectors: [],
    formulations: [],
    customer_sources: [],
    customer_leads: [],
    account_handlers: [],
    customer_user_types: [],
    formulation_applications: [],
    formulation_carriers: [],
    currencies: [],
    raw_materials: [],
    sundry_suppliers: [],
    vam_types: []
  },
  mutations: {
    SET_CUSTOMERS: (state, customers) => (state.customers = customers),
    SET_COUNTRIES: (state, countries) => (state.countries = countries),
    SET_SUPPLIERS: (state, suppliers) => (state.suppliers = suppliers),
    SET_SUNDRY_SUPPLIERS: (state, sundry_suppliers) => (state.sundry_suppliers = sundry_suppliers),
    SET_STAFFS: (state, staffs) => (state.staffs = staffs),
    SET_FILTERED_STAFFS: (state, staffs) => (state.filtered_staffs = staffs),
    SET_INDUSTRY_SECTORS: (state, industry_sectors) => (state.industry_sectors = industry_sectors),
    SET_FORMULATIONS: (state, formulations) => (state.formulations = formulations),
    SET_CUSTOMER_SOURCES: (state, customer_sources) => (state.customer_sources = customer_sources),
    SET_CUSTOMER_LEADS: (state, customer_leads) => (state.customer_leads = customer_leads),
    SET_ACCOUNT_HANDLERS: (state, account_handlers) => (state.account_handlers = account_handlers),
    SET_CUSTOMER_USER_TYPES: (state, types) => (state.customer_user_types = types),
    SET_FORMULATION_APPLICATIONS: (state, formulation_applications) => (state.formulation_applications = formulation_applications),
    SET_FORMULATION_CARRIERS: (state, formulation_carriers) => (state.formulation_carriers = formulation_carriers),
    SET_CURRENCIES: (state, currencies) => (state.currencies = currencies),
    SET_RAW_MATERIAL: (state, raw_materials) => (state.raw_materials = raw_materials),
    SET_VAM_TYPES: (state, vam_types) => (state.vam_types = vam_types),
  },
  getters: {
    customers: state => state.customers,
    countries: state => state.countries,
    suppliers: state => state.suppliers,
    staffs: state => state.staffs,
    filtered_staffs: state => state.filtered_staffs,
    industry_sectors: state => state.industry_sectors,
    formulations: state => state.formulations,
    customer_sources: state => state.customer_sources,
    customer_leads: state => state.customer_leads,
    account_handlers: state => state.account_handlers,
    customer_user_types: state => state.customer_user_types,
    formulation_applications: state => state.formulation_applications,
    formulation_carriers: state => state.formulation_carriers,
    currencies: state => state.currencies,
    raw_materials: state => state.raw_materials,
    sundry_suppliers: state => state.sundry_suppliers,
    vam_types: state => state.vam_types,
  },
  actions: {
    async fetchCustomers ({commit, state}) {
      if(state.customers.length === 0) {
        const {data} = (await DropDownRepository.getCustomersList()).data
        commit('SET_CUSTOMERS', data.map((x) => ({ name: x.company_name, value: x.id })));
      }
    },
    async fetchSuppliers ({commit, state}) {
      if(state.suppliers.length === 0) {
        const {data} = (await DropDownRepository.getApprovedSupplierList()).data
        commit('SET_SUPPLIERS', data.map((x) => ({ name: x.company_name, value: x.id })));
      }
    },
    async fetchSundrySuppliers ({commit, state}) {
      if(state.sundry_suppliers.length === 0) {
        const {data} = (await DropDownRepository.getApprovedSundrySupplierList()).data
        commit('SET_SUNDRY_SUPPLIERS', data.map((x) => ({ name: x.company_name, value: x.id })));
      }
    },
    async fetchCountries ({commit, state}) {
      if(state.countries.length === 0) {
        const {data} = (await CustomerRepository.getCountryCodes()).data
        commit('SET_COUNTRIES', data.map((x) => ({ name: x.name, value: x.name, iso_code: x.iso_code })));
      }
    },
    async fetchStaffs ({commit, state}) {
      if(state.staffs.length === 0) {
        const {data} = (await DropDownRepository.getStaffList()).data
        commit('SET_STAFFS', data.map((x) => ({ name: x.name, value: x.id, is_active: x.is_active, is_leave_enabled: x.is_leave_enabled })));
      }
    },
    async fetchFilteredStaffs ({commit, state}) {
      const {data} = (await DropDownRepository.getStaffList('filter[is_active]=1')).data
      const list = is_live
        ? data.filter(x => !x.email.toLowerCase().endsWith('@souqbox.net'))
        : data

      const mapped = list.map(x => ({
        name: x.name,
        value: x.id,
        is_active: x.is_active,
        is_leave_enabled: x.is_leave_enabled
      }))
      commit('SET_FILTERED_STAFFS', mapped);
    },
    async fetchIndustrySections ({commit, state}) {
      if(state.industry_sectors.length === 0) {
        const {data} = (await CustomerRepository.getIndustrySectors('')).data
        commit('SET_INDUSTRY_SECTORS', data.map((x) => ({ name: x.name, value: x.id })));
      }
    },
    async fetchFormulations ({commit,state}) {
      if(state.formulations.length === 0){
        const {data} = (await FormulationRepository.getListOfFormulationNoPagination()).data
        commit('SET_FORMULATIONS', data.map((x) => ({name: x.name , value: x.id, formulation_code: x.formulation_code})));
      }
    },
    async fetchCustomerSources({commit, state}) {
      if(state.customer_sources.length === 0){
        const { data } = (await CustomerSourceRepository.getListOfCustomerSource()).data
        commit('SET_CUSTOMER_SOURCES', data.map((x) => ({name: x.name , value: x.id})))
      }
    },
    async fetchCustomerLeads({commit, state}) {
      if(state.customer_leads.length === 0){
        const { data } = (await DropDownRepository.getCustomerLeadList()).data
        commit('SET_CUSTOMER_LEADS', data.map((x) => ({name: x.company_name , value: x.id})))
      }
    },
    async fetchAccountHandlers ({commit}) {
      const {data} = (await DropDownRepository.getStaffAccountHandlers()).data
      commit('SET_ACCOUNT_HANDLERS', data.map((x) => ({ name: x.name, value: x.id })));
    },
    async fetchCustomerUserTypes ({commit}) {
      const {data} = (await DropDownRepository.getCustomerUserTypes()).data
      commit('SET_CUSTOMER_USER_TYPES', data.map((x) => ({ name: x.name, value: x.id })));
    },
    async fetchFormulationApplications({commit, state}) {
      if(state.formulation_applications.length === 0){
        const { data } = (await FormulationRepository.getFormulaApplications()).data
        commit('SET_FORMULATION_APPLICATIONS', data.map((x) => ({ name: x.name, value: x.id })));
      }
    },
    async fetchFormulationCarriers({commit, state}) {
      if(state.formulation_carriers.length === 0){
        const { data } = (await DropDownRepository.getCarrierList()).data
        commit('SET_FORMULATION_CARRIERS', data.map((x) => ({ name: x.name, value: x.code })));
      }
    },
    async fetchCurrencyList({commit, state}) {
      if(state.currencies.length === 0){
        const { data } = (await StaffRepository.getCurrencyList()).data
        commit('SET_CURRENCIES', data.map((x) => ({ name: x.name, value: x.code })));
      }
    },
    async fetchRawMaterial({commit, state}) {
      if(state.raw_materials.length === 0){
        const res = (await SupplierRawMaterialRepository.getRawMaterialAcceptedList(1, 'is_paginate=0', 150, '', 0)).data
        const data = Array.isArray(res) ? res : (res.data || [])
        commit('SET_RAW_MATERIAL', data.map((x) => ({ name: `${(x.category && x.category.prefix) || ''}-${x.company_product_code}`, value: x.id })));
      }
    },
    async fetchVamTypes({commit, state}) {
      if(state.vam_types.length === 0){
        const { data } = (await CrmRepository.getListVamType()).data
        commit('SET_VAM_TYPES', data.map((x) => ({ name: x.name, value: x.name })));
      }
    },
  }
}
